module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "add-custom-banner flex-start",
    staticStyle: {
      "background": "#fff",
      "margin": "10rpx 0"
    }
  }, _vm._l((_vm.content), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "add-custom-nav",
      on: {
        "click": function($event) {
          return _vm.onPicClick(item)
        }
      }
    }, [_c('img', {
      staticClass: "add-custom-img",
      attrs: {
        "src": item.pic_url,
        "mode": "widthFix"
      }
    })])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3627c452","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/Pic.vue
// module id = 2317
// module chunks = 0